var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPpt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.111,
    height: 40,
    viewBox: "0 0 31.111 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ppt_icon",
    transform: "translate(-12 -4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3801",
    "data-name": "Path 3801",
    d: "M12.5,43.944V4.5H33.222l9.833,9.833V43.944Z",
    transform: "translate(-0.222 -0.222)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3802",
    "data-name": "Path 3802",
    d: "M32.889,4.556l9.667,9.667V43.444h-30V4.556H32.889M33.111,4H12V44H43.111V14l-10-10Z",
    fill: "#c76443"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3803",
    "data-name": "Path 3803",
    d: "M49.5,14.5V4.5h.167L59.5,14.333V14.5Z",
    transform: "translate(-16.667 -0.222)",
    fill: "#ffd9cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3804",
    "data-name": "Path 3804",
    d: "M49.556,4.778,58.778,14H49.556V4.778m0-.778H49V14.556H59.556V14l-10-10Z",
    transform: "translate(-16.444)",
    fill: "#cf6846"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3805",
    "data-name": "Path 3805",
    d: "M32.556,52.222A.525.525,0,0,1,32,51.667V40.556a.556.556,0,1,1,1.111,0V51.667A.525.525,0,0,1,32.556,52.222Z",
    transform: "translate(-8.889 -16)",
    fill: "#c76443"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3806",
    "data-name": "Path 3806",
    d: "M37,43.111c-2.611,0-5-2.889-5-6.111a.556.556,0,0,1,1.111,0c0,2.5,1.944,5,3.889,5,2.111,0,3.889-2.056,3.889-4.444S39.111,33.111,37,33.111H32.556a.556.556,0,1,1,0-1.111H37c2.722,0,5,2.556,5,5.556S39.722,43.111,37,43.111Z",
    transform: "translate(-8.889 -12.444)",
    fill: "#c76443"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPpt);
export default __webpack_public_path__ + "static/media/ppt.f919198c590ad1b4a28deba9d94db2a7.svg";
export { ForwardRef as ReactComponent };